module.exports = __webpack_public_path__ + "static/media/8773.08d32265.png";